import axios from "axios";

export interface ObservedApiResponse {
  method: string;
  url: string;
  requestBody: unknown;
  responseBody: unknown;
}

type ApiResponseObserver = (response: ObservedApiResponse) => void;

const observers = new Set<ApiResponseObserver>();

const parseJson = (body: unknown): unknown => {
  if (typeof body !== "string") return body;
  try {
    return JSON.parse(body);
  } catch {
    return body;
  }
};

// Every request, legacy `api/methods` and generated Orval alike, goes through this one axios
// instance, so this sees each successful response exactly once. Rejected requests never reach it.
axios.interceptors.response.use((response) => {
  const observed: ObservedApiResponse = {
    method: (response.config.method ?? "get").toUpperCase(),
    url: response.config.url ?? "",
    requestBody: parseJson(response.config.data),
    responseBody: response.data,
  };
  for (const observer of observers) {
    try {
      observer(observed);
    } catch (error) {
      // An observer is a side channel and must never fail the request it watches.
      console.error("[ApiResponseObserver]", error);
    }
  }
  return response;
});

/** Calls `observer` for every successful API response. Registering the same function twice is a no-op. */
export function observeApiResponses(observer: ApiResponseObserver): void {
  observers.add(observer);
}
